export class EmrIntegrationConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "accountId",
            "baseName": "accountId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EmrIntegrationConfig.attributeTypeMap;
    }
    constructor() {
    }
}
